import {
  TextToPayCompletePaymentRequest,
  TextToPayCompletePaymentResponse,
  TextToPayVisitView,
} from '@m/types/api';
import { apiFetchV2 } from '@m/utils/http';

export const PaymentService = {
  getVisitDetails: ({
    visitCode,
    useSiteRowView = false,
  }: {
    useSiteRowView?: boolean;
    visitCode: string;
  }) =>
    apiFetchV2<TextToPayVisitView>(`/customer/text-to-pay/details/${visitCode}`, {
      params: {
        useSiteRowView,
      },
    }),

  completePayment: ({
    visitCode,
    ...body
  }: TextToPayCompletePaymentRequest & {
    visitCode: string;
  }) =>
    apiFetchV2<TextToPayCompletePaymentResponse>(`/customer/text-to-pay/complete/${visitCode}`, {
      method: 'POST',
      body,
    }),

  wrongVehicle: ({ visitCode }: { visitCode: string }) =>
    apiFetchV2<void>(`/customer/text-to-pay/wrong-vehicle/${visitCode}`, { method: 'PUT' }),
};
